import type { ButtonVariantProps } from "@homeinstead/ui/components/Button";
import type { LeadFlowThemeContrast } from "../types";

/**
 * Light text marks a dark theme, where the primary button would sink into
 * the paint, so actions there use the Friendly button.
 */
function getButtonVariant(
  themeContrast: LeadFlowThemeContrast,
): ButtonVariantProps["variant"] {
  return themeContrast === "light" ? "friendly" : "primary";
}

export { getButtonVariant };
